import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  translationButtonText: {
    id: 'unit-translation-selector-plugin.translationSelection.translationButtonText',
    defaultMessage: 'Translate',
    description: 'Button text for the translation selector',
  },
  translationTourModalTitle: {
    id: 'unit-translation-selector-plugin.translationSelection.translationTourModalTitle',
    defaultMessage: 'New translation feature!',
    description: 'Title for the translation modal.',
  },
  translationTourModalBody: {
    id: 'unit-translation-selector-plugin.translationSelection.translationTourModalBody',
    defaultMessage: 'Now you can easily translate course content.',
    description: 'Body for the translation modal.',
  },
  tryItButtonText: {
    id: 'unit-translation-selector-plugin.translationSelection.tryItButtonText',
    defaultMessage: 'Try it',
    description: 'Button text for the translation modal.',
  },
  dismissButtonText: {
    id: 'unit-translation-selector-plugin.translationSelection.dismissButtonText',
    defaultMessage: 'Dismiss',
    description: 'Button text for the translation modal.',
  },
});

export default messages;
